import { render, staticRenderFns } from "./AppRefreshButton.vue?vue&type=template&id=3019e83e&scoped=true&"
import script from "./AppRefreshButton.vue?vue&type=script&lang=js&"
export * from "./AppRefreshButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3019e83e",
  null
  
)

export default component.exports